"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyTransformations = void 0;
// TODO: remove `compat` and fix the types. https://es-toolkit.slash.page/compatibility.html
// `GenericTableDataRow` should extend `object` and
// `sort.selector` should be `(keyof GenericTableDataRow | ((item: GenericTableDataRow) => unknown))[]`.
const compat_1 = require("es-toolkit/compat");
/**
 * This function takes in an array of rows and applies sorting and filtering
 * onto it before returning the transformed array of rows.
 * @param data the array of rows to be transformed by the table hook
 * @param transformers (filter and sort) to be applied to the data
 * @returns an array of rows transformed by the filter and sort functions passed in
 */
const applyTransformations = (data, { filter, sort } = {}) => {
    let rows = data;
    if (filter)
        rows = rows.filter(filter);
    if (sort)
        rows = (0, compat_1.orderBy)(rows, sort.selector, sort.direction);
    return rows;
};
exports.applyTransformations = applyTransformations;
//# sourceMappingURL=useTable.utils.js.map